





































import { Component, Vue } from 'vue-property-decorator'
import { User } from '@/api/model/user'
import { cloneDeep } from 'lodash'
import { UserAPI } from '@/api/backend-client'

@Component
export default class UserSettings extends Vue {
    loading: boolean = false
    user: User = null
    submitting: boolean = false

    async created() {
        await this.reload()
    }

    async reload() {
        this.user = cloneDeep<any>(this.$currentUser)
        this.user.company = this.$currentCompany
    }

    async save() {
        try {
            this.loading = true
            this.submitting = true
            this.$root.$currentUser = await UserAPI.update(this.user.id, this.user)
            await this.reload()

        } finally {
            this.loading = false
            this.submitting = false
        }
    }
}
